export const privacy = {
  // SEO
  title: 'سياسة الخصوصية - KiraCar',
  description: 'تعرف على كيفية حماية KiraCar لخصوصيتك والتعامل مع بياناتك الشخصية. تغطي سياسة الخصوصية الشاملة لدينا جمع البيانات والاستخدام وحقوقك.',
  keywords: 'سياسة الخصوصية، حماية البيانات، GDPR، البيانات الشخصية، KiraCar، تأجير السيارات، حقوق الخصوصية',
  
  // Hero Section
  heroTitle: 'سياسة الخصوصية',
  heroDescription: 'خصوصيتك مهمة بالنسبة لنا. توضح هذه السياسة كيفية جمع معلوماتك واستخدامها وحمايتها.',
  lastUpdated: 'آخر تحديث',
  
  // Sections
  introduction: {
    title: 'مقدمة',
    paragraph1: 'تلتزم KiraCar ("نحن" أو "خاصتنا" أو "لنا") بحماية خصوصيتك. توضح سياسة الخصوصية هذه كيفية جمع معلوماتك واستخدامها والكشف عنها وحمايتها عند استخدام منصة تأجير السيارات وخدماتنا.',
    paragraph2: 'باستخدام خدماتنا، فإنك توافق على جمع المعلومات واستخدامها وفقًا لهذه السياسة. إذا كنت لا توافق على سياساتنا وممارساتنا، يرجى عدم استخدام خدماتنا.'
  },
  
  informationWeCollect: {
    title: 'المعلومات التي نجمعها',
    personalInformation: {
      title: 'المعلومات الشخصية',
      accountInfo: { title: 'معلومات الحساب', description: 'الاسم، عنوان البريد الإلكتروني، رقم الهاتف، تاريخ الميلاد، صورة الملف الشخصي' },
      identityDocs: { title: 'وثائق الهوية', description: 'رخصة القيادة، جواز السفر، بطاقة الهوية، تصريح الإقامة' },
      locationData: { title: 'بيانات الموقع', description: 'أماكن الاستلام والإرجاع، إحداثيات GPS، معلومات العنوان' }
    },
    bookingInformation: {
      title: 'معلومات الحجز',
      rentalDetails: { title: 'تفاصيل التأجير', description: 'تواريخ الاستلام والإرجاع، تفضيلات المركبة، مدة التأجير، معلومات التسعير' },
      paymentInfo: { title: 'معلومات الدفع', description: 'تفاصيل طريقة الدفع، سجل المعاملات، عنوان الفوترة (معالج بأمان من خلال مقدمي خدمات الطرف الثالث)' }
    },
    technicalInformation: {
      title: 'المعلومات التقنية',
      usageData: { title: 'بيانات الاستخدام', description: 'عنوان IP، نوع المتصفح، معلومات الجهاز، نظام التشغيل، الصفحات التي تمت زيارتها، الوقت المستغرق على الموقع' },
      cookies: { title: 'ملفات تعريف الارتباط والتتبع', description: 'ملفات تعريف الارتباط للجلسة، ملفات تعريف الارتباط للتفضيلات، ملفات تعريف الارتباط للتحليلات، ملفات تعريف الارتباط للتسويق' }
    }
  },
  
  howWeUse: {
    title: 'كيف نستخدم معلوماتك',
    serviceDelivery: { badge: 'تقديم الخدمة', title: 'تقديم خدماتنا', description: 'معالجة الحجوزات، إدارة التأجيرات، معالجة المدفوعات، تقديم دعم العملاء' },
    communication: { badge: 'الاتصال', title: 'الاتصال', description: 'إرسال تأكيدات الحجز، تذكيرات التأجير، تحديثات الخدمة، الاتصالات التسويقية (بموافقتك)' },
    security: { badge: 'الأمان', title: 'الأمان ومنع الاحتيال', description: 'التحقق من الهوية، منع الاحتيال، ضمان أمان المنصة، الامتثال للمتطلبات القانونية' },
    improvement: { badge: 'التحسين', title: 'تحسين الخدمة', description: 'تحليل أنماط الاستخدام، تحسين تجربة المستخدم، تطوير ميزات جديدة، إجراء البحوث' },
    legal: { badge: 'قانوني', title: 'الامتثال القانوني', description: 'الامتثال للقوانين المعمول بها، الرد على الطلبات القانونية، حماية حقوقنا ومصالحنا' }
  },
  
  informationSharing: {
    title: 'مشاركة المعلومات',
    intro: 'لا نبيع أو نتاجر أو نؤجر معلوماتك الشخصية لأطراف ثالثة. قد نشارك معلوماتك فقط في الحالات التالية:',
    serviceProviders: { badge: 'مقدمو الخدمات', title: 'مقدمو الخدمات الموثوقون', description: 'معالجات الدفع، خدمات البريد الإلكتروني، مقدمي التحليلات، مقدمي التخزين السحابي (بموجب اتفاقيات صارمة لحماية البيانات)' },
    businessPartners: { badge: 'الشركاء التجاريون', title: 'الشركاء التجاريون', description: 'وكالات تأجير السيارات، مقدمي التأمين، خدمات الصيانة (فقط المعلومات اللازمة لتقديم الخدمة)' },
    legalRequirements: { badge: 'المتطلبات القانونية', title: 'المتطلبات القانونية', description: 'عندما يقتضي القانون أو أمر المحكمة أو طلب الحكومة' },
    safety: { badge: 'السلامة', title: 'السلامة والأمان', description: 'لحماية مستخدمينا، منع الاحتيال، أو ضمان أمان المنصة' }
  },
  
  dataSecurity: {
    title: 'أمان البيانات',
    intro: 'ننفذ التدابير التقنية والتنظيمية المناسبة لحماية معلوماتك الشخصية:',
    encryption: { title: 'التشفير', description: 'يتم تشفير جميع البيانات أثناء النقل وعند الراحة باستخدام بروتوكولات التشفير القياسية في الصناعة' },
    accessControls: { title: 'ضوابط الوصول', description: 'ضوابط الوصول الصارمة وآليات المصادقة تحد من من يمكنه الوصول إلى بياناتك' },
    regularAudits: { title: 'التدقيقات المنتظمة', description: 'التدقيقات الأمنية المنتظمة وتقييمات الثغرات لتحديد المخاطر المحتملة ومعالجتها' },
    secureInfrastructure: { title: 'البنية التحتية الآمنة', description: 'مستضافة على بنية تحتية سحابية آمنة ومتوافقة مع النسخ الاحتياطي والمراقبة المنتظمة' }
  },
  
  yourRights: {
    title: 'حقوق الخصوصية الخاصة بك',
    intro: 'لديك الحقوق التالية فيما يتعلق بمعلوماتك الشخصية:',
    access: { badge: 'الوصول', title: 'حق الوصول', description: 'طلب نسخة من المعلومات الشخصية التي نحتفظ بها عنك' },
    correction: { badge: 'التصحيح', title: 'حق التصحيح', description: 'طلب تصحيح المعلومات الشخصية غير الدقيقة أو غير الكاملة' },
    deletion: { badge: 'الحذف', title: 'حق الحذف', description: 'طلب حذف معلوماتك الشخصية (مع مراعاة الالتزامات القانونية والتعاقدية)' },
    portability: { badge: 'قابلية النقل', title: 'حق قابلية نقل البيانات', description: 'طلب نقل بياناتك إلى مقدم خدمة آخر' },
    objection: { badge: 'الاعتراض', title: 'حق الاعتراض', description: 'الاعتراض على معالجة معلوماتك الشخصية لأغراض معينة' },
    withdraw: { badge: 'السحب', title: 'حق سحب الموافقة', description: 'سحب الموافقة على المعالجة القائمة على الموافقة في أي وقت' }
  },
  
  cookies: {
    title: 'ملفات تعريف الارتباط وتقنيات التتبع',
    intro: 'نستخدم ملفات تعريف الارتباط وتقنيات التتبع المماثلة لتحسين تجربتك:',
    essential: { badge: 'أساسي', title: 'ملفات تعريف الارتباط الأساسية', description: 'مطلوبة للوظائف الأساسية للموقع، المصادقة والأمان' },
    analytics: { badge: 'التحليلات', title: 'ملفات تعريف الارتباط للتحليلات', description: 'تساعدنا على فهم كيفية استخدامك لموقعنا لتحسين خدماتنا' },
    preferences: { badge: 'التفضيلات', title: 'ملفات تعريف الارتباط للتفضيلات', description: 'تذكر إعداداتك وتفضيلاتك لتجربة مخصصة' },
    marketing: { badge: 'التسويق', title: 'ملفات تعريف الارتباط للتسويق', description: 'تُستخدم لتقديم إعلانات ذات صلة وقياس فعالية الحملات (بموافقتك)' }
  },
  
  dataRetention: {
    title: 'الاحتفاظ بالبيانات',
    intro: 'نحتفظ بمعلوماتك الشخصية فقط طالما كان ذلك ضروريًا لتحقيق الأغراض الموضحة في هذه السياسة:',
    accountData: { badge: 'بيانات الحساب', title: 'معلومات الحساب', description: 'يتم الاحتفاظ بها أثناء نشاط حسابك ولمدة 3 سنوات بعد إغلاق الحساب لأغراض قانونية وتجارية' },
    bookingData: { badge: 'بيانات الحجز', title: 'سجلات الحجز', description: 'يتم الاحتفاظ بها لمدة 7 سنوات لأغراض المحاسبة والقانونية وتسوية المنازعات' },
    marketingData: { badge: 'بيانات التسويق', title: 'الاتصالات التسويقية', description: 'يتم الاحتفاظ بها حتى إلغاء الاشتراك أو سحب الموافقة' },
    analyticsData: { badge: 'بيانات التحليلات', title: 'بيانات التحليلات', description: 'مجهولة الهوية ويتم الاحتفاظ بها لمدة تصل إلى عامين لتحسين الخدمة' }
  },
  
  internationalTransfers: {
    title: 'التحويلات الدولية للبيانات',
    intro: 'قد يتم نقل معلوماتك الشخصية ومعالجتها في بلدان غير بلد إقامتك. نضمن وجود ضمانات مناسبة:',
    adequacy: { badge: 'الكفاية', title: 'قرارات الكفاية', description: 'التحويلات إلى البلدان التي لديها قوانين كافية لحماية البيانات' },
    sccs: { badge: 'CCN', title: 'البنود التعاقدية القياسية', description: 'البنود التعاقدية المعتمدة من الاتحاد الأوروبي للتحويلات الدولية' },
    certification: { badge: 'الشهادة', title: 'خطط الشهادة', description: 'المشاركة في خطط شهادات حماية البيانات المعترف بها' }
  },
  
  childrenPrivacy: {
    title: 'خصوصية الأطفال',
    intro: 'خدماتنا غير مخصصة للأطفال دون سن 18 عامًا. لا نجمع معلومات شخصية عن قصد من الأطفال دون سن 18. إذا كنت والدًا أو وصيًا وتعتقد أن طفلك قد زودنا بمعلومات شخصية، يرجى الاتصال بنا على الفور.',
    importantNotice: { title: 'إشعار مهم', description: 'إذا اكتشفنا أننا جمعنا معلومات شخصية من طفل دون سن 18، فسنحذف هذه المعلومات على الفور.' }
  },
  
  contactUs: {
    title: 'اتصل بنا',
    intro: 'إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه أو ممارساتنا المتعلقة بالبيانات، يرجى الاتصال بنا:',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    address: 'العنوان',
    addressLine1: 'KiraCar',
    addressLine2: 'المغرب',
    addressLine3: 'الدار البيضاء، المغرب'
  },
  
  changesToPolicy: {
    title: 'التغييرات على هذه السياسة',
    intro: 'قد نحدث سياسة الخصوصية هذه من وقت لآخر. سنخطرك بأي تغييرات من خلال:',
    notification: { badge: 'الإشعار', title: 'إشعار البريد الإلكتروني', description: 'إرسال إشعار بريد إلكتروني بالتغييرات المهمة' },
    website: { badge: 'الموقع', title: 'إشعار الموقع', description: 'نشر السياسة المحدثة على موقعنا مع تاريخ "آخر تحديث" جديد' },
    inApp: { badge: 'في التطبيق', title: 'إشعار في التطبيق', description: 'عرض إشعار في تطبيقنا المحمول أو موقعنا' },
    yourRights: { title: 'حقوقك', description: 'الاستمرار في استخدام خدماتنا بعد التغييرات يشكل قبولًا للسياسة المحدثة. يمكنك سحب الموافقة في أي وقت.' }
  },
  
  footer: {
    effectiveDate: 'دخلت سياسة الخصوصية هذه حيز التنفيذ في',
    lastUpdated: 'وتم تحديثها آخر مرة في',
    copyright: 'جميع الحقوق محفوظة.'
  }
};
